import "./App.css";
import Homepage from "./Pages/Homepage";
import { Route } from "react-router-dom";
import Menu from "./components/menu";
// import SideDrawer from "./components/miscellaneous/SideDrawer";
import { ChatState } from "./Context/ChatProvider";
import { useEffect, useState } from "react";

import Users from "./components/Admin/users";
import Students from "./components/Admin/students";
import Teachers from "./components/Admin/teachers";
import Groups from "./components/Admin/group";
import Levels from "./components/Admin/level";
import Payement from "./components/Admin/payement";
import StudentInscription from "./components/Admin/student/studentInscription";
import StudentsIn from "./components/Admin/studentsIn";

function App() {
   const { user } = ChatState();
   const [isAdmin,setIsAdmin]=useState()
   useEffect(()=>{
      if(user){
        setIsAdmin(user.isAdmin)
      }
   },[user])
   
  return (
    <>
    
    <div className="App relative px-2">
    {user && <Menu/>} 
    <Route path="/login" component={Homepage} />
    <Route path="/user" component={Users} />
    <Route path="/student" component={Students} />
    <Route path="/teacher" component={Teachers}  />
    <Route path="/group" component={Groups}  />
    <Route path="/level" component={Levels}  />
    <Route path="/payement" component={Payement}  />
    
    <Route path="/ins" component={StudentsIn} />
    </div>
    <div className="App absolute top-0">
    <Route path="/inscription" component={StudentInscription} />
    </div>
  
    </>
  //   {/*  <div>
  //   <div className="bar w-full h-fit ">
  //   {user && <SideDrawer />}
  //   </div> 
  // </div> */}
  );
}

export default App;
